import { render, staticRenderFns } from "./FoodModifiers.vue?vue&type=template&id=bb22d1f6&"
import script from "./FoodModifiers.vue?vue&type=script&lang=js&"
export * from "./FoodModifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports